import React from "react";
import { Modal, Button } from "react-bootstrap";

const SuccessModal = ({ show, handleClose, report }) => {

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center">
        <h5 className="fw-bold">Report Successfully Sent</h5>
        <br></br>
        <br></br>
        <p>Workflow report has been successfully sent to ADCU-Checker</p>
        <br></br>
        <br></br>
        <Button variant="primary" onClick={handleClose}>
          Continue
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
